import React from 'react';
import * as HomeUI from '../HomeUI';
import FavoritedReportsContent from './FavoritedReportsContent';

const FavoritedReports = () => (
  <section>
    <HomeUI.SectionTitle>Favorited Reports</HomeUI.SectionTitle>
    <FavoritedReportsContent />
  </section>
);

export default FavoritedReports;
